<script setup lang="ts">
import { VBtn, VIcon, VTooltip } from 'vuetify/components';

export type SquaredIconButtonProps = {
  icon?: string;
  tooltip?: string;
  iconAttrs?: VIcon['$props'];
  tooltipAttrs?: VTooltip['$props'];
  buttonAttrs?: VBtn['$props'];
};

defineEmits<{ click: [event: Event] }>();

withDefaults(defineProps<SquaredIconButtonProps>(), {
  iconAttrs: () => ({}),
  tooltipAttrs: () => ({}),
});
</script>

<template>
  <VBtn variant="text" size="x-small" icon rounded="lg" v-bind="buttonAttrs" @click.stop="$emit('click', $event)">
    <slot name="icon" v-bind="{ size: 16, color: 'grey-darken-2', icon, ...iconAttrs }" :props="{ size: 16, color: 'grey-darken-2', icon, ...iconAttrs }">
      <VIcon size="16" color="grey-darken-2" :icon v-bind="iconAttrs" />
    </slot>

    <slot />

    <VTooltip v-if="tooltip || $slots.tooltip" activator="parent" location="top" open-delay="250" v-bind="tooltipAttrs" class="tw:print:hidden">
      <slot name="tooltip">
        {{ tooltip }}
      </slot>
    </VTooltip>
  </VBtn>
</template>
